"use strict";
//
// @Javi: This is my custom debounce. I used multiple sources and migrate them to typescript
// There is a function and a decorator
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerInstanceDebounce = exports.Debounce = exports.debounce = void 0;
/**
 * Debounce function
 * @param func A function
 * @param interval The time to wait
 */
function debounce(func, interval) {
    // Id of the last timeout our undefined
    let lastCall = undefined;
    return function (...args) {
        // If we ar in another call, remove the last one
        if (lastCall)
            clearTimeout(lastCall);
        // Add a new timeout
        const self = this;
        lastCall = setTimeout(function () {
            func.apply(self, args);
        }, interval);
    };
}
exports.debounce = debounce;
/**
 * This is the Debounce decorator
 * @param interval
 * @constructor
 */
function Debounce(interval) {
    return function (target, propertyKey, descriptor) {
        const method = descriptor.value;
        descriptor.value = debounce(method, interval);
    };
}
exports.Debounce = Debounce;
/**
 * This is the PerInstanceDebounce decorator. It is similar to the Debounce decorator but each debounce
 * work per object instance instead of class.
 * @param interval The time between calls
 * @param id_field By default we use the vue '_uid' attribute to differentiate the objects
 * @constructor
 */
function PerInstanceDebounce(interval, id_field = '_uid') {
    const lastCalls = {};
    return function (target, propertyKey, descriptor) {
        // Original function
        const original = descriptor.value;
        // override original function body
        descriptor.value = function per_instance_debounce(...args) {
            // If we ar in another call, remove the last one
            const id = this[id_field];
            if (!id) {
                throw new Error(`Object has not attribute '${id_field}', unable to create a debounce`);
            }
            const lastCall = lastCalls[id];
            if (lastCall)
                clearTimeout(lastCall);
            // sechudle timer
            lastCalls[id] = setTimeout(() => {
                // call original function
                original.apply(this, args);
            }, interval);
        };
        // return descriptor with new value
        return descriptor;
    };
}
exports.PerInstanceDebounce = PerInstanceDebounce;
